// components/auth/OrgPrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../../session/SessionProvider";

const OrgPrivateRoute = ({ children }) => {
  const { user, loading } = useSession();
  if (loading) return null;
  if (!user?.token) return <Navigate to="/" replace />;

  const perms = user?.perms || [];
  const hasOrgAccess = perms.some((p) => typeof p === "string" && (p.startsWith("org:") || p.startsWith("platform:")));
  return hasOrgAccess ? children : <Navigate to="/dashboard" replace />;
};

export default OrgPrivateRoute;
